import { accessGateConstants } from '../actions/constants';

const initialState = {
    open: false,
    code: null,
    status: null,
    feature: null,
    scope: null,
    title: '',
    message: '',
    officeId: null,
    userId: null,
    productId: null,
    sceneId: null,
    requestUrl: '',
    method: '',
    payload: {},
    createdAt: null,
    updatedAt: null,
    dismissedAt: null,
};

const normalizePayload = (payload = {}) => {
    const data = payload && typeof payload === 'object' ? payload : {};

    return {
        ...data,
        payload: data.payload && typeof data.payload === 'object' ? data.payload : {},
    };
};

export default function accessGateReducer(state = initialState, action) {
    switch (action.type) {
        case accessGateConstants.ACCESS_GATE_OPEN: {
            const payload = normalizePayload(action.payload);
            const now = new Date().toISOString();

            return {
                ...state,
                ...payload,
                open: true,
                createdAt: state.open && state.createdAt ? state.createdAt : now,
                updatedAt: now,
                dismissedAt: null,
            };
        }

        case accessGateConstants.ACCESS_GATE_PATCH:
            return {
                ...state,
                ...normalizePayload(action.payload),
                updatedAt: new Date().toISOString(),
            };

        case accessGateConstants.ACCESS_GATE_CLOSE:
            return {
                ...state,
                open: false,
                dismissedAt: new Date().toISOString(),
            };

        case accessGateConstants.ACCESS_GATE_CLEAR:
            return initialState;

        default:
            return state;
    }
}
